<h3 class="mb-1" appTitleProvider>{{ 'TASKS' | translate }}</h3>

<app-table class="patient-tasks-table" [loadingItems]="loading">
    <ng-container header>
        @if (coloringTaskFeatureEnabled | async) {
            <th class="flex-2">
            </th>
        }
        <th class="flex-4" appTitleProvider>
            <span>{{ 'TASK' | translate }}</span>
        </th>
        <th class="flex-9" appTitleProvider>
            <span>{{ 'TIME' | translate }}</span>
        </th>
        @if (showRoster && !editing) {
            <th class="flex-4" appTitleProvider>
                <span>{{ 'ROSTER_NAME' | translate }}</span>
            </th>
        }
        <th class="flex-4" appTitleProvider>
            <span>{{ 'DURATION' | translate }}</span>
        </th>
        <th class="flex-5" appTitleProvider>
            <span>{{ 'SHIFT_TYPE' | translate }}</span>
        </th>
        <th class="flex-5" appTitleProvider>
            <span>{{ 'COMPETENCE' | translate }}</span>
        </th>
        <th class="flex-3" appTitleProvider>
            <span>{{ 'EMPLOYEES_COUNT' | translate }}</span>
        </th>
        @if (editing) {
            <th class="flex-3 justify-content-center" appTitleProvider>
                <span>{{ 'PERMANENT' | translate }}</span>
            </th>
        }
        @if ((breakPointValue >= BreakpointValue.LARGE && editing) || !editing) {
            <th class="flex-5" appTitleProvider>
                <span>{{ 'COMPATIBLE_MAIN_RESPONSIBLES' | translate }}</span>
            </th>
        }
        <th class="flex-3 justify-content-center" appTitleProvider>
            <span class="w-100 mx-0">{{ 'ACTIVE' | translate }}</span>
        </th>
        <th class="flex-4 justify-content-center" appTitleProvider>
            <span>{{ 'ACTIONS' | translate }}</span>
        </th>
        <th class="flex-4 justify-content-center"></th>
        <th class="flex-3"></th>
    </ng-container>
    <ng-container body>
        @for (task of tasks; track task.taskId) {
            @if (!task.editing) {
                <tr
                    (contextmenu)="openModalWindow(task, $event)"
                    (contextmenu)="getMousePosition($event)"
                    [ngClass]="{'patient-task-disabled': !task.isActive}"
                >
                    @if (coloringTaskFeatureEnabled | async) {
                        <td class="flex-2">
                            <div class="task-color mx-auto"
                                 [ngStyle]="{'background-color': task.color ? task.color : 'white' }"
                                 (click)="openColorPopover(task, $event)">
                            </div>
                        </td>
                    }
                    <td class="flex-4" appTitleProvider>
                        <span>{{ task.taskDescription }}</span>
                    </td>
                    <td class="flex-9" appTitleProvider>
                        <span>{{ task | fromto }}</span>
                    </td>
                    @if (showRoster && !editing) {
                        <td class="flex-4" appTitleProvider>
                            <span>{{ task.rosterDepartmentName }}</span>
                        </td>
                    }
                    <td class="flex-4" appTitleProvider>
                        <span>{{ task.duration }} min</span>
                    </td>
                    <td class="flex-5" appTitleProvider>
                        <span>{{ task.shiftType }}</span>
                    </td>
                    <td class="flex-5" appTitleProvider>
                        <span>{{ task.skillRequirementDescription }}</span>
                    </td>
                    <td class="flex-3" appTitleProvider>
                        <span>{{ task.numberOfEmployees }}</span>
                    </td>
                    @if (editing) {
                        <td class="flex-2"></td>
                    }
                    @if ((breakPointValue >= BreakpointValue.LARGE && editing) || !editing) {
                        <td
                            class="flex-5 justify-content-center">
                            @for (responsible of task.mainResponsibleEmployees | slice: 0:1; track responsible) {
                                <span
                                    class="responsible-initials"
                                    [ngClass]="{ primary: responsible.primaryContact, secondary: responsible.secondaryContact }"
                                >
                                    {{ responsible.initials }}
                                    </span>
                            }
                            @if (task.mainResponsibleEmployees.length > 1) {
                                <app-tooltip
                                    appCustomPopover
                                    [popoverText]="getHiddenInitials(task)"
                                    placement="top"
                                    [compact]="true"
                                >
                                    <ng-container icon>
                                        <span
                                            class="responsible-initials"> +{{ task.mainResponsibleEmployees.length - 1 }} </span>
                                    </ng-container>
                                </app-tooltip>
                            }
                        </td>
                    }
                    <td class="flex-3">
                    <span [ngClass]="{'icon-checkmark': task.isActive,
                                      'icon-close-blue': !task.isActive }" class="mx-auto">
                    </span>
                    </td>
                    <td class="flex-4 justify-content-center">
                        <app-tooltip
                            title="{{'EDIT_TASK' | translate}}"
                            [compact]="true"
                            (click)="edit(task, $event)"
                        >
                            <ng-container icon>
                                @if (!task.isSyncedInitially) {
                                    <span
                                        class="vismaicon vismaicon-sm vismaicon-edit"
                                        [ngClass]="{
                                    disabled:
                                        patient.addressUpdating || patient.taskUpdating || patient.feasibilityReloading
                                }"
                                    ></span>
                                }
                            </ng-container>
                        </app-tooltip>
                    </td>
                    <td class="flex-4 justify-content-center">
                        @if (task.isSyncedInitially) {
                            <app-tooltip
                                class="ml-1"
                                popoverText="TASK_SYNCED_INFO_DELETE_MRP"
                                appCustomPopover
                                placement="left"
                                [adaptPlacement]="true"
                            >
                                <ng-container icon>
                                    <span class="icon-merge"></span>
                                </ng-container>
                            </app-tooltip>
                        }
                        @if (!task.doesRequirePhysicalAppearance) {
                            <app-tooltip
                                appCustomPopover
                                class="ml-1"
                                popoverText="TASK_REQUIRE_PHYSICAL_APPEARANCE_INFO"
                                placement="left"
                                [adaptPlacement]="true"
                            >
                                <ng-container icon>
                                    <span class="icon-phone"></span>
                                </ng-container>
                            </app-tooltip>
                        }
                        @if (task.isHeavy) {
                            <app-tooltip
                                appCustomPopover
                                popoverText="TASK_HEAVY_INFO"
                                placement="left"
                                [adaptPlacement]="true"
                            >
                                <ng-container icon>
                                    <span class="icon-heavy-weight"></span>
                                </ng-container>
                            </app-tooltip>
                        }
                    </td>
                    <td class="flex-3 justify-content-center">
                        @if ((!patient.feasibilityReloading || editing) && !task.updating) {
                            <app-feasibility-info
                                [feasibilityInfo]="task.feasibilityInfo"
                            ></app-feasibility-info>
                        }
                        @if ((patient.feasibilityReloading && !editing) || task.updating) {
                            <div class="spinner"></div>
                        }
                    </td>
                </tr>
            }
            @if (task.editing) {
                <app-patient-task-edit [task]="task" [patient]="patient"
                                       [showRoster]="showRoster"
                                       [breakPointValue]="breakPointValue"
                                       [coloringTaskFeatureEnabled]="coloringTaskFeatureEnabled"
                ></app-patient-task-edit>
            }
        }
        @if (showRestrictionContextMenu) {
            <div
                class="context-menu"
                (click)="openEmployeesRestrictionModal()"
                [style.top.px]="showRestrictionContextMenuTopPosition"
                [style.left.px]="showRestrictionContextMenuLeftPosition"
            >
                <span class="vismaicon vismaicon-users vismaicon-no-hover"></span>
                {{ 'SHOW_RESTRICTIONS' | translate }}
            </div>
        }
    </ng-container>
</app-table>

